import classes from "./HomeSection.module.css";
import React from "react";
import logo from "../../images/chandan2.jpg";
// import cv from "../../images/chandancv.pdf";
const HomeSection = () => {
  return (
    <>
      <div className={classes.centerbox}>
        <div className={classes.centertext}>
          <div className={classes.column}>
            <div className={classes.img}>
              <img src={logo} className={classes.imgborder} alt="logo" />
            </div>
            <div>
              <p>Heloo</p>
              <h2>&lt;I'm Chandan Singh&#47;&gt;</h2>
              <h1>Engineering Student</h1>
              <div className={classes.btn}>
                <a>Cv</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeSection;
